function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import AsyncStorage from "@react-native-async-storage/async-storage";
import * as Sentry from "@sentry/core";
import * as Updates from "expo-updates";
import { useEffect, useState } from "react";
import { Platform, Linking as RNLinking } from "react-native";
import { setPersistedState } from "./usePersistedState";
import { authClient } from "../lib/auth";
import { parseUrl } from "../lib/parseUrl";
export function useDetoxSideEffects() {
    var _useState = _sliced_to_array(useState(false), 2), forceOffline = _useState[0], setForceOffline = _useState[1];
    useEffect(function() {
        var handleDetoxNotification = function handleDetoxNotification(data) {
            if (data.type === 'NETWORK') {
                setForceOffline(!data.payload.isInternetReachable);
            } else if (data.type === 'LAST_SEEN') {
                authClient.setLastSeen(Number(data.payload.value));
            } else if (data.type === 'ASYNC_STORAGE') {
                AsyncStorage.setItem(data.payload.key, data.payload.value).catch(Sentry.captureException);
            } else if (data.type === 'EXPO_CHANNEL') {
                Updates.setUpdateURLAndRequestHeadersOverride({
                    updateUrl: "https://u.expo.dev/".concat(data.payload.expoProjectID),
                    requestHeaders: {
                        'expo-channel-name': data.payload.channel
                    }
                });
            } else if (data.type === 'BIOMETRICS') {
                if (data.payload.enable === 'true') {
                    authClient.enableBiometricAuthentication().catch(Sentry.captureException);
                } else {
                    authClient.disableBiometricAuthentication().catch(Sentry.captureException);
                }
            }
        };
        var handleOpenURL = function(param) {
            var url = param.url;
            var parsedUrl = parseUrl(url);
            if (global.e2e && (parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.path) === 'DETOX_NOTIFICATION') {
                var data = JSON.parse(parsedUrl.params.data);
                handleDetoxNotification(data);
                return;
            }
            if (parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.params.skipLocalAuthenticationPrompt) {
                setPersistedState('SeenLocalAuthenticationPrompt', JSON.parse(parsedUrl.params.skipLocalAuthenticationPrompt));
            }
        };
        if (Platform.OS === 'web') {
            // @ts-ignore
            global.window.__detoxNotificationCallback = function(data) {
                handleDetoxNotification(JSON.parse(data));
            };
        } else {
            var urlSubscription = RNLinking.addEventListener('url', handleOpenURL);
            RNLinking.getInitialURL().then(function(url) {
                if (url) handleOpenURL({
                    url: url
                });
            }).catch(Sentry.captureException);
            return function() {
                urlSubscription.remove();
            };
        }
        return;
    }, []);
    return {
        forceOffline: forceOffline
    };
}
